import introduction from './content/introduction'
import authentication from './content/authentication'
import errors from './content/errors'
import shipments from './content/shipments'
import returns from './content/returns'
import webhooks from './content/webhooks'
import session from './content/session'
import shipmentObjects from './content/shipmentObjects'
import returnObjects from './content/returnObjects'
import productTypes from './content/productTypes'
import shippingConsiderations from './content/shippingConsiderations'

/**
 * Sidebar structure of the API docs. To add a page: create a markdown module under
 * ./content/, import it above, and add an entry below (or a new group).
 */
export const docsGroups = [
  {
    group: 'Getting Started',
    groupKey: 'DocsGroupGettingStarted',
    items: [
      { id: 'introduction', title: 'Introduction', titleKey: 'DocsTitleIntroduction', content: introduction },
      { id: 'authentication', title: 'Authentication', titleKey: 'DocsTitleAuthentication', content: authentication },
      { id: 'errors', title: 'Errors', titleKey: 'DocsTitleErrors', content: errors }
    ]
  },
  {
    group: 'API Reference',
    groupKey: 'DocsGroupApiReference',
    items: [
      {
        id: 'shipments',
        title: 'Shipments (Outbox)',
        titleKey: 'DocsTitleShipments',
        content: shipments,
        children: [
          { title: 'Check availability and price', anchor: '1-check-availability-and-price', method: 'GET' },
          { title: 'Upload the PDF', anchor: '2-upload-the-pdf', method: 'POST' },
          { title: 'Confirm the shipment', anchor: '3-confirm-the-shipment', method: 'PUT' },
          { title: 'Get shipment metadata', anchor: 'step-1-get-the-shipment-metadata', method: 'GET' },
          { title: 'Submit cancellation update', anchor: 'step-3-submit-the-cancellation-update', method: 'PUT' },
          { title: 'List shipments', anchor: 'list-shipments', method: 'POST' }
        ]
      },
      {
        id: 'returns',
        title: 'Returns (Inbox)',
        titleKey: 'DocsTitleReturns',
        content: returns,
        children: [
          { title: 'Count unread returns', anchor: '1-count-unread-returns', method: 'GET' },
          { title: 'List return summaries', anchor: '2-list-return-summaries', method: 'GET' },
          { title: 'Query state details', anchor: '3-query-state-details', method: 'GET' },
          { title: 'Mark returns as read', anchor: '4-mark-returns-as-read', method: 'PUT' },
          { title: 'Download files', anchor: '5-download-proof-certificate-or-document-files', method: 'GET' }
        ]
      },
      {
        id: 'webhooks',
        title: 'Webhook (Watcher)',
        titleKey: 'DocsTitleWebhooks',
        content: webhooks,
        children: [
          { title: 'Register watcher', anchor: 'register-a-webhook-watcher', method: 'PUT' },
          { title: 'Callback request', anchor: 'callback-request-sent-by-postamail', method: 'POST' }
        ]
      }
    ]
  },
  {
    group: 'Object Types',
    groupKey: 'DocsGroupObjectTypes',
    items: [
      { id: 'session', title: 'Session', titleKey: 'DocsTitleSession', content: session },
      {
        id: 'shipment-objects',
        title: 'Shipment objects',
        titleKey: 'DocsTitleShipmentObjects',
        content: shipmentObjects,
        children: [
          { title: 'ShipmentPriceDetails', anchor: 'shipmentpricedetails' },
          { title: 'DraftInfo', anchor: 'draftinfo' },
          { title: 'Shipment', anchor: 'shipment' },
          { title: 'ShipmentPages', anchor: 'shipmentpages' },
          { title: 'ShipmentAddress', anchor: 'shipmentaddress' },
          { title: 'ShipmentFeatures', anchor: 'shipmentfeatures' }
        ]
      },
      {
        id: 'return-objects',
        title: 'Return objects',
        titleKey: 'DocsTitleReturnObjects',
        content: returnObjects,
        children: [
          { title: 'FeedbackReturn', anchor: 'feedbackreturn' },
          { title: 'StateInfo', anchor: 'stateinfo' },
          { title: 'ProofInfo', anchor: 'proofinfo' },
          { title: 'CertInfo', anchor: 'certinfo' },
          { title: 'DocumentInfo', anchor: 'documentinfo' },
          { title: 'StampedCopyInfo', anchor: 'stampedcopyinfo' }
        ]
      }
    ]
  },
  {
    group: 'Annexes',
    groupKey: 'DocsGroupAnnexes',
    items: [
      { id: 'product-types', title: 'Product types', titleKey: 'DocsTitleProductTypes', content: productTypes },
      {
        id: 'shipping-considerations',
        title: 'Shipping considerations',
        titleKey: 'DocsTitleShippingConsiderations',
        content: shippingConsiderations
      }
    ]
  }
]

export const DEFAULT_DOC_ID = 'introduction'

export function findDocById(id) {
  for (const group of docsGroups) {
    const found = group.items.find(item => item.id === id)
    if (found) return found
  }
  return null
}



// WEBPACK FOOTER //
// ./src/components/docs/api/docsConfig.js